import React from 'react';
import SelectOTA from "~/features/base/components/forms/ota/SelectOTA";
import {useFetchBlockedReasonsQuery} from "~/api/controlDevice/ControlDevice.api";
import {formatLabel} from "~/features/base/utils/formatLabel";

interface BlockedReasonItemProps {
    onBlockedReasonChange: (reason: string) => void;
    blockedReason?: string;
    disabled?: boolean;
}

const BlockedReasonItem: React.FC<BlockedReasonItemProps> = ({
                                                                   onBlockedReasonChange,
                                                                   blockedReason,
                                                                 disabled
                                                               }) => {
    const { data } = useFetchBlockedReasonsQuery({});

    const options = data?.map(reason => ({
        label: formatLabel(reason),
        id: reason,
        value: reason
    }));

    const handleChange = (selectedOption) => {
        const value = Array.isArray(selectedOption) ? selectedOption[0]?.value : selectedOption?.value;
        onBlockedReasonChange(value);
    };

    return (
        <div className='form-group'>
            <SelectOTA
                title='intl-msg:blockedReason'
                useFilter
                useClear
                options={options}
                disabled={disabled}
                value={[blockedReason]}
                onChange={handleChange}
            />
        </div>
    );
};

export default React.memo(BlockedReasonItem);
